import { convertToEnumWithOptions } from '../utils/convert-to-option';

export const accountFilterFields = ['name', 'creditorNumber'];

export const accountSelectLabel = object => {
  return `${object.name} - ${object.creditorNumber}`;
};

export const ACCOUNT_TYPES = [
  { label: 'Agency', value: 'Agency' },
  { label: 'Fashion', value: 'Fashion' },
  { label: 'Non-Fashion', value: 'Non-Fashion' },
];

export const ZALANDO_ACCOUNT_SF_ID = '0017Q00001HkxHOQAZ';

export const ZALANDO_EMAIL = 'conditions@zalando.de';

export const csvColumns = [
  { accessor: 'id', label: 'Id' },
  { accessor: 'name', label: 'Name' },
  { accessor: 'number', label: 'Number' },
  { accessor: 'businessPartnerId', label: 'Business Partner Id' },
  { accessor: 'creditorNumber', label: 'Creditor Number' },
  { accessor: 'debitorNumber', label: 'Debitor Number' },
  { accessor: 'mandatoryPoNumber', label: 'Mandatory Po Number' },
  { accessor: 'taxNumber', label: 'Tax Number' },
  { accessor: 'termsAndConditions', label: 'Terms And Conditions' },
  { accessor: 'type', label: 'Type' },
  { accessor: 'addressStreet', label: 'Address Street' },
  { accessor: 'addressHouseNumber', label: 'Address House Number' },
  { accessor: 'addressZip', label: 'Address Zip' },
  { accessor: 'addressCity', label: 'Address City' },
  { accessor: 'addressCountry', label: 'Address Country' },
  { accessor: 'businessPartnerName', label: 'Business Partner Name' },
  { accessor: 'billingEmails', label: 'Billing Email' },
  { accessor: 'iban', label: 'IBAN' },
  { accessor: 'bic', label: 'BIC' },
  { accessor: 'sapStatus', label: 'SAP Status' },
  { accessor: 'eligibleForCampaigns', label: 'Eligible For Campaigns' },
  {
    accessor: 'eligibleForMonthlyBilling',
    label: 'Eligible For Monthly Billing',
  },
  { accessor: 'paymentTerms.name', label: 'Payment Terms' },
];

const PENDING = 'Pending';
const READY = 'Ready';

export const EDIT = 'Edit';

export const helperTextEditAccount =
  'Keep in mind that, if you want to update certain fields for an existing Account (Banking Details, email address, etc), you need to submit the updated data to the Accounting team via accounts-receivable-b2b@zalando.de. The Accounting team will then proceed with the changes.';

export const sapStatuses = {
  [PENDING]: PENDING,
  [READY]: READY,
};

export const sapStatusOptions = Object.values(
  convertToEnumWithOptions(sapStatuses),
);

export const mandatoryCampaignEligibility =
  '(mandatory to fill for campaign eligibility)';

export const HELP_TEXTS = {
  header: {
    paymentTermsId:
      'If you leave this field empty, by default the Payment Term will be selected as 14 TG, if this account needs another value, only Support or Controlling team can change the value.',
  },
};

export const accountCountries = [
  { label: 'AF (Afghanistan)', countryCode: 'AF', name: 'Afghanistan' },
  { label: 'AX (Åland Islands)', countryCode: 'AX', name: 'Åland Islands' },
  { label: 'AL (Albania)', countryCode: 'AL', name: 'Albania' },
  { label: 'DZ (Algeria)', countryCode: 'DZ', name: 'Algeria' },
  { label: 'AS (American Samoa)', countryCode: 'AS', name: 'American Samoa' },
  { label: 'AD (Andorra)', countryCode: 'AD', name: 'Andorra' },
  { label: 'AO (Angola)', countryCode: 'AO', name: 'Angola' },
  { label: 'AI (Anguilla)', countryCode: 'AI', name: 'Anguilla' },
  { label: 'AQ (Antarctica)', countryCode: 'AQ', name: 'Antarctica' },
  {
    label: 'AG (Antigua and Barbuda)',
    countryCode: 'AG',
    name: 'Antigua and Barbuda',
  },
  { label: 'AR (Argentina)', countryCode: 'AR', name: 'Argentina' },
  { label: 'AM (Armenia)', countryCode: 'AM', name: 'Armenia' },
  { label: 'AW (Aruba)', countryCode: 'AW', name: 'Aruba' },
  { label: 'AU (Australia)', countryCode: 'AU', name: 'Australia' },
  { label: 'AT (Austria)', countryCode: 'AT', name: 'Austria' },
  { label: 'AZ (Azerbaijan)', countryCode: 'AZ', name: 'Azerbaijan' },
  { label: 'BS (Bahamas)', countryCode: 'BS', name: 'Bahamas' },
  { label: 'BH (Bahrain)', countryCode: 'BH', name: 'Bahrain' },
  { label: 'BD (Bangladesh)', countryCode: 'BD', name: 'Bangladesh' },
  { label: 'BB (Barbados)', countryCode: 'BB', name: 'Barbados' },
  { label: 'BY (Belarus)', countryCode: 'BY', name: 'Belarus' },
  { label: 'BE (Belgium)', countryCode: 'BE', name: 'Belgium' },
  { label: 'BZ (Belize)', countryCode: 'BZ', name: 'Belize' },
  { label: 'BJ (Benin)', countryCode: 'BJ', name: 'Benin' },
  { label: 'BM (Bermuda)', countryCode: 'BM', name: 'Bermuda' },
  { label: 'BT (Bhutan)', countryCode: 'BT', name: 'Bhutan' },
  { label: 'BO (Bolivia)', countryCode: 'BO', name: 'Bolivia' },
  {
    label: 'BQ (Bonaire, Sint Eustatius and Saba)',
    countryCode: 'BQ',
    name: 'Bonaire, Sint Eustatius and Saba',
  },
  {
    label: 'BA (Bosnia and Herzegovina)',
    countryCode: 'BA',
    name: 'Bosnia and Herzegovina',
  },
  { label: 'BW (Botswana)', countryCode: 'BW', name: 'Botswana' },
  { label: 'BR (Brazil)', countryCode: 'BR', name: 'Brazil' },
  {
    label: 'IO (British Indian Ocean Territory)',
    countryCode: 'IO',
    name: 'British Indian Ocean Territory',
  },
  {
    label: 'BN (Brunei Darussalam)',
    countryCode: 'BN',
    name: 'Brunei Darussalam',
  },
  { label: 'BG (Bulgaria)', countryCode: 'BG', name: 'Bulgaria' },
  { label: 'BF (Burkina Faso)', countryCode: 'BF', name: 'Burkina Faso' },
  { label: 'BI (Burundi)', countryCode: 'BI', name: 'Burundi' },
  { label: 'KH (Cambodia)', countryCode: 'KH', name: 'Cambodia' },
  { label: 'CM (Cameroon)', countryCode: 'CM', name: 'Cameroon' },
  { label: 'CA (Canada)', countryCode: 'CA', name: 'Canada' },
  { label: 'CV (Cape Verde)', countryCode: 'CV', name: 'Cape Verde' },
  { label: 'KY (Cayman Islands)', countryCode: 'KY', name: 'Cayman Islands' },
  {
    label: 'CF (Central African Republic)',
    countryCode: 'CF',
    name: 'Central African Republic',
  },
  { label: 'TD (Chad)', countryCode: 'TD', name: 'Chad' },
  { label: 'CL (Chile)', countryCode: 'CL', name: 'Chile' },
  { label: 'CN (China)', countryCode: 'CN', name: 'China' },
  {
    label: 'CX (Christmas Island)',
    countryCode: 'CX',
    name: 'Christmas Island',
  },
  {
    label: 'CC (Cocos (Keeling) Islands)',
    countryCode: 'CC',
    name: 'Cocos (Keeling) Islands',
  },
  { label: 'CO (Colombia)', countryCode: 'CO', name: 'Colombia' },
  { label: 'KM (Comoros)', countryCode: 'KM', name: 'Comoros' },
  { label: 'CG (Congo)', countryCode: 'CG', name: 'Congo' },
  {
    label: 'CD (Congo, The Democratic Republic of the)',
    countryCode: 'CD',
    name: 'Congo, The Democratic Republic of the',
  },
  { label: 'CK (Cook Islands)', countryCode: 'CK', name: 'Cook Islands' },
  { label: 'CR (Costa Rica)', countryCode: 'CR', name: 'Costa Rica' },
  { label: "CI (Côte d'Ivoire)", countryCode: 'CI', name: "Côte d'Ivoire" },
  { label: 'HR (Croatia)', countryCode: 'HR', name: 'Croatia' },
  { label: 'CU (Cuba)', countryCode: 'CU', name: 'Cuba' },
  { label: 'CW (Curaçao)', countryCode: 'CW', name: 'Curaçao' },
  { label: 'CY (Cyprus)', countryCode: 'CY', name: 'Cyprus' },
  { label: 'CZ (Czech Republic)', countryCode: 'CZ', name: 'Czech Republic' },
  { label: 'DK (Denmark)', countryCode: 'DK', name: 'Denmark' },
  { label: 'DJ (Djibouti)', countryCode: 'DJ', name: 'Djibouti' },
  { label: 'DM (Dominica)', countryCode: 'DM', name: 'Dominica' },
  {
    label: 'DO (Dominican Republic)',
    countryCode: 'DO',
    name: 'Dominican Republic',
  },
  { label: 'EC (Ecuador)', countryCode: 'EC', name: 'Ecuador' },
  { label: 'EG (Egypt)', countryCode: 'EG', name: 'Egypt' },
  { label: 'SV (El Salvador)', countryCode: 'SV', name: 'El Salvador' },
  {
    label: 'GQ (Equatorial Guinea)',
    countryCode: 'GQ',
    name: 'Equatorial Guinea',
  },
  { label: 'ER (Eritrea)', countryCode: 'ER', name: 'Eritrea' },
  { label: 'EE (Estonia)', countryCode: 'EE', name: 'Estonia' },
  { label: 'SZ (Eswatini)', countryCode: 'SZ', name: 'Eswatini' },
  { label: 'ET (Ethiopia)', countryCode: 'ET', name: 'Ethiopia' },
  {
    label: 'FK (Falkland Islands (Malvinas))',
    countryCode: 'FK',
    name: 'Falkland Islands (Malvinas)',
  },
  { label: 'FO (Faroe Islands)', countryCode: 'FO', name: 'Faroe Islands' },
  { label: 'FJ (Fiji)', countryCode: 'FJ', name: 'Fiji' },
  { label: 'FI (Finland)', countryCode: 'FI', name: 'Finland' },
  { label: 'FR (France)', countryCode: 'FR', name: 'France' },
  { label: 'GF (French Guiana)', countryCode: 'GF', name: 'French Guiana' },
  {
    label: 'PF (French Polynesia)',
    countryCode: 'PF',
    name: 'French Polynesia',
  },
  {
    label: 'TF (French Southern Territories)',
    countryCode: 'TF',
    name: 'French Southern Territories',
  },
  { label: 'GA (Gabon)', countryCode: 'GA', name: 'Gabon' },
  { label: 'GM (Gambia)', countryCode: 'GM', name: 'Gambia' },
  { label: 'GE (Georgia)', countryCode: 'GE', name: 'Georgia' },
  { label: 'DE (Germany)', countryCode: 'DE', name: 'Germany' },
  { label: 'GH (Ghana)', countryCode: 'GH', name: 'Ghana' },
  { label: 'GI (Gibraltar)', countryCode: 'GI', name: 'Gibraltar' },
  { label: 'GR (Greece)', countryCode: 'GR', name: 'Greece' },
  { label: 'GL (Greenland)', countryCode: 'GL', name: 'Greenland' },
  { label: 'GD (Grenada)', countryCode: 'GD', name: 'Grenada' },
  { label: 'GP (Guadeloupe)', countryCode: 'GP', name: 'Guadeloupe' },
  { label: 'GU (Guam)', countryCode: 'GU', name: 'Guam' },
  { label: 'GT (Guatemala)', countryCode: 'GT', name: 'Guatemala' },
  { label: 'GG (Guernsey)', countryCode: 'GG', name: 'Guernsey' },
  { label: 'GN (Guinea)', countryCode: 'GN', name: 'Guinea' },
  { label: 'GW (Guinea-Bissau)', countryCode: 'GW', name: 'Guinea-Bissau' },
  { label: 'GY (Guyana)', countryCode: 'GY', name: 'Guyana' },
  { label: 'HT (Haiti)', countryCode: 'HT', name: 'Haiti' },
  {
    label: 'HM (Heard Island and McDonald Islands)',
    countryCode: 'HM',
    name: 'Heard Island and McDonald Islands',
  },
  {
    label: 'VA (Holy See (Vatican City State))',
    countryCode: 'VA',
    name: 'Holy See (Vatican City State)',
  },
  { label: 'HN (Honduras)', countryCode: 'HN', name: 'Honduras' },
  { label: 'HK (Hong Kong)', countryCode: 'HK', name: 'Hong Kong' },
  { label: 'HU (Hungary)', countryCode: 'HU', name: 'Hungary' },
  { label: 'IS (Iceland)', countryCode: 'IS', name: 'Iceland' },
  { label: 'IN (India)', countryCode: 'IN', name: 'India' },
  { label: 'ID (Indonesia)', countryCode: 'ID', name: 'Indonesia' },
  {
    label: 'XZ (Installations in International Waters)',
    countryCode: 'XZ',
    name: 'Installations in International Waters',
  },
  {
    label: 'IR (Iran, Islamic Republic of)',
    countryCode: 'IR',
    name: 'Iran, Islamic Republic of',
  },
  { label: 'IQ (Iraq)', countryCode: 'IQ', name: 'Iraq' },
  { label: 'IE (Ireland)', countryCode: 'IE', name: 'Ireland' },
  { label: 'IM (Isle of Man)', countryCode: 'IM', name: 'Isle of Man' },
  { label: 'IL (Israel)', countryCode: 'IL', name: 'Israel' },
  { label: 'IT (Italy)', countryCode: 'IT', name: 'Italy' },
  { label: 'JM (Jamaica)', countryCode: 'JM', name: 'Jamaica' },
  { label: 'JP (Japan)', countryCode: 'JP', name: 'Japan' },
  { label: 'JE (Jersey)', countryCode: 'JE', name: 'Jersey' },
  { label: 'JO (Jordan)', countryCode: 'JO', name: 'Jordan' },
  { label: 'KZ (Kazakhstan)', countryCode: 'KZ', name: 'Kazakhstan' },
  { label: 'KE (Kenya)', countryCode: 'KE', name: 'Kenya' },
  { label: 'KI (Kiribati)', countryCode: 'KI', name: 'Kiribati' },
  {
    label: "KP (Korea, Democratic People's Republic of)",
    countryCode: 'KP',
    name: "Korea, Democratic People's Republic of",
  },
  {
    label: 'KR (Korea, Republic of)',
    countryCode: 'KR',
    name: 'Korea, Republic of',
  },
  { label: 'KW (Kuwait)', countryCode: 'KW', name: 'Kuwait' },
  { label: 'KG (Kyrgyzstan)', countryCode: 'KG', name: 'Kyrgyzstan' },
  {
    label: "LA (Lao People's Democratic Republic)",
    countryCode: 'LA',
    name: "Lao People's Democratic Republic",
  },
  { label: 'LV (Latvia)', countryCode: 'LV', name: 'Latvia' },
  { label: 'LB (Lebanon)', countryCode: 'LB', name: 'Lebanon' },
  { label: 'LS (Lesotho)', countryCode: 'LS', name: 'Lesotho' },
  { label: 'LR (Liberia)', countryCode: 'LR', name: 'Liberia' },
  { label: 'LY (Libya)', countryCode: 'LY', name: 'Libya' },
  { label: 'LI (Liechtenstein)', countryCode: 'LI', name: 'Liechtenstein' },
  { label: 'LT (Lithuania)', countryCode: 'LT', name: 'Lithuania' },
  { label: 'LU (Luxembourg)', countryCode: 'LU', name: 'Luxembourg' },
  { label: 'MO (Macao)', countryCode: 'MO', name: 'Macao' },
  { label: 'MG (Madagascar)', countryCode: 'MG', name: 'Madagascar' },
  { label: 'MW (Malawi)', countryCode: 'MW', name: 'Malawi' },
  { label: 'MY (Malaysia)', countryCode: 'MY', name: 'Malaysia' },
  { label: 'MV (Maldives)', countryCode: 'MV', name: 'Maldives' },
  { label: 'ML (Mali)', countryCode: 'ML', name: 'Mali' },
  { label: 'MT (Malta)', countryCode: 'MT', name: 'Malta' },
  {
    label: 'MH (Marshall Islands)',
    countryCode: 'MH',
    name: 'Marshall Islands',
  },
  { label: 'MQ (Martinique)', countryCode: 'MQ', name: 'Martinique' },
  { label: 'MR (Mauritania)', countryCode: 'MR', name: 'Mauritania' },
  { label: 'MU (Mauritius)', countryCode: 'MU', name: 'Mauritius' },
  { label: 'YT (Mayotte)', countryCode: 'YT', name: 'Mayotte' },
  { label: 'MX (Mexico)', countryCode: 'MX', name: 'Mexico' },
  {
    label: 'FM (Micronesia, Federated States of)',
    countryCode: 'FM',
    name: 'Micronesia, Federated States of',
  },
  {
    label: 'MD (Moldova, Republic of)',
    countryCode: 'MD',
    name: 'Moldova, Republic of',
  },
  { label: 'MC (Monaco)', countryCode: 'MC', name: 'Monaco' },
  { label: 'MN (Mongolia)', countryCode: 'MN', name: 'Mongolia' },
  { label: 'ME (Montenegro)', countryCode: 'ME', name: 'Montenegro' },
  { label: 'MS (Montserrat)', countryCode: 'MS', name: 'Montserrat' },
  { label: 'MA (Morocco)', countryCode: 'MA', name: 'Morocco' },
  { label: 'MZ (Mozambique)', countryCode: 'MZ', name: 'Mozambique' },
  { label: 'MM (Myanmar)', countryCode: 'MM', name: 'Myanmar' },
  { label: 'NA (Namibia)', countryCode: 'NA', name: 'Namibia' },
  { label: 'NR (Nauru)', countryCode: 'NR', name: 'Nauru' },
  { label: 'NP (Nepal)', countryCode: 'NP', name: 'Nepal' },
  { label: 'NL (Netherlands)', countryCode: 'NL', name: 'Netherlands' },
  { label: 'NC (New Caledonia)', countryCode: 'NC', name: 'New Caledonia' },
  { label: 'NZ (New Zealand)', countryCode: 'NZ', name: 'New Zealand' },
  { label: 'NI (Nicaragua)', countryCode: 'NI', name: 'Nicaragua' },
  { label: 'NE (Niger)', countryCode: 'NE', name: 'Niger' },
  { label: 'NG (Nigeria)', countryCode: 'NG', name: 'Nigeria' },
  { label: 'NU (Niue)', countryCode: 'NU', name: 'Niue' },
  { label: 'NF (Norfolk Island)', countryCode: 'NF', name: 'Norfolk Island' },
  { label: 'MK (North Macedonia)', countryCode: 'MK', name: 'North Macedonia' },
  {
    label: 'MP (Northern Mariana Islands)',
    countryCode: 'MP',
    name: 'Northern Mariana Islands',
  },
  { label: 'NO (Norway)', countryCode: 'NO', name: 'Norway' },
  { label: 'OM (Oman)', countryCode: 'OM', name: 'Oman' },
  { label: 'PK (Pakistan)', countryCode: 'PK', name: 'Pakistan' },
  { label: 'PW (Palau)', countryCode: 'PW', name: 'Palau' },
  {
    label: 'PS (Palestine, State of)',
    countryCode: 'PS',
    name: 'Palestine, State of',
  },
  { label: 'PA (Panama)', countryCode: 'PA', name: 'Panama' },
  {
    label: 'PG (Papua New Guinea)',
    countryCode: 'PG',
    name: 'Papua New Guinea',
  },
  { label: 'PY (Paraguay)', countryCode: 'PY', name: 'Paraguay' },
  { label: 'PE (Peru)', countryCode: 'PE', name: 'Peru' },
  { label: 'PH (Philippines)', countryCode: 'PH', name: 'Philippines' },
  { label: 'PN (Pitcairn)', countryCode: 'PN', name: 'Pitcairn' },
  { label: 'PL (Poland)', countryCode: 'PL', name: 'Poland' },
  { label: 'PT (Portugal)', countryCode: 'PT', name: 'Portugal' },
  { label: 'PR (Puerto Rico)', countryCode: 'PR', name: 'Puerto Rico' },
  { label: 'QA (Qatar)', countryCode: 'QA', name: 'Qatar' },
  { label: 'RE (Reunion)', countryCode: 'RE', name: 'Reunion' },
  { label: 'RO (Romania)', countryCode: 'RO', name: 'Romania' },
  {
    label: 'RU (Russian Federation)',
    countryCode: 'RU',
    name: 'Russian Federation',
  },
  { label: 'RW (Rwanda)', countryCode: 'RW', name: 'Rwanda' },
  {
    label: 'BL (Saint Barthélemy)',
    countryCode: 'BL',
    name: 'Saint Barthélemy',
  },
  {
    label: 'SH (Saint Helena, Ascension and Tristan Da Cunha)',
    countryCode: 'SH',
    name: 'Saint Helena, Ascension and Tristan Da Cunha',
  },
  {
    label: 'KN (Saint Kitts and Nevis)',
    countryCode: 'KN',
    name: 'Saint Kitts and Nevis',
  },
  { label: 'LC (Saint Lucia)', countryCode: 'LC', name: 'Saint Lucia' },
  {
    label: 'MF (Saint Martin (French Part))',
    countryCode: 'MF',
    name: 'Saint Martin (French Part)',
  },
  {
    label: 'PM (Saint Pierre and Miquelon)',
    countryCode: 'PM',
    name: 'Saint Pierre and Miquelon',
  },
  {
    label: 'VC (Saint Vincent and the Grenadines)',
    countryCode: 'VC',
    name: 'Saint Vincent and the Grenadines',
  },
  { label: 'WS (Samoa)', countryCode: 'WS', name: 'Samoa' },
  { label: 'SM (San Marino)', countryCode: 'SM', name: 'San Marino' },
  {
    label: 'ST (Sao Tome and Principe)',
    countryCode: 'ST',
    name: 'Sao Tome and Principe',
  },
  { label: 'SA (Saudi Arabia)', countryCode: 'SA', name: 'Saudi Arabia' },
  { label: 'SN (Senegal)', countryCode: 'SN', name: 'Senegal' },
  { label: 'RS (Serbia)', countryCode: 'RS', name: 'Serbia' },
  { label: 'SC (Seychelles)', countryCode: 'SC', name: 'Seychelles' },
  { label: 'SL (Sierra Leone)', countryCode: 'SL', name: 'Sierra Leone' },
  { label: 'SG (Singapore)', countryCode: 'SG', name: 'Singapore' },
  {
    label: 'SX (Sint Maarten (Dutch Part))',
    countryCode: 'SX',
    name: 'Sint Maarten (Dutch Part)',
  },
  { label: 'SK (Slovakia)', countryCode: 'SK', name: 'Slovakia' },
  { label: 'SI (Slovenia)', countryCode: 'SI', name: 'Slovenia' },
  { label: 'SB (Solomon Islands)', countryCode: 'SB', name: 'Solomon Islands' },
  { label: 'SO (Somalia)', countryCode: 'SO', name: 'Somalia' },
  { label: 'ZA (South Africa)', countryCode: 'ZA', name: 'South Africa' },
  {
    label: 'GS (South Georgia and the South Sandwich Islands)',
    countryCode: 'GS',
    name: 'South Georgia and the South Sandwich Islands',
  },
  { label: 'SS (South Sudan)', countryCode: 'SS', name: 'South Sudan' },
  { label: 'ES (Spain)', countryCode: 'ES', name: 'Spain' },
  { label: 'LK (Sri Lanka)', countryCode: 'LK', name: 'Sri Lanka' },
  { label: 'SD (Sudan)', countryCode: 'SD', name: 'Sudan' },
  { label: 'SR (Suriname)', countryCode: 'SR', name: 'Suriname' },
  {
    label: 'SJ (Svalbard and Jan Mayen)',
    countryCode: 'SJ',
    name: 'Svalbard and Jan Mayen',
  },
  { label: 'SE (Sweden)', countryCode: 'SE', name: 'Sweden' },
  { label: 'CH (Switzerland)', countryCode: 'CH', name: 'Switzerland' },
  {
    label: 'SY (Syrian Arab Republic)',
    countryCode: 'SY',
    name: 'Syrian Arab Republic',
  },
  { label: 'TW (Taiwan)', countryCode: 'TW', name: 'Taiwan' },
  { label: 'TJ (Tajikistan)', countryCode: 'TJ', name: 'Tajikistan' },
  {
    label: 'TZ (Tanzania, United Republic of)',
    countryCode: 'TZ',
    name: 'Tanzania, United Republic of',
  },
  { label: 'TH (Thailand)', countryCode: 'TH', name: 'Thailand' },
  { label: 'TL (Timor-Leste)', countryCode: 'TL', name: 'Timor-Leste' },
  { label: 'TG (Togo)', countryCode: 'TG', name: 'Togo' },
  { label: 'TK (Tokelau)', countryCode: 'TK', name: 'Tokelau' },
  { label: 'TO (Tonga)', countryCode: 'TO', name: 'Tonga' },
  {
    label: 'TT (Trinidad and Tobago)',
    countryCode: 'TT',
    name: 'Trinidad and Tobago',
  },
  { label: 'TN (Tunisia)', countryCode: 'TN', name: 'Tunisia' },
  { label: 'TR (Turkey)', countryCode: 'TR', name: 'Turkey' },
  { label: 'TM (Turkmenistan)', countryCode: 'TM', name: 'Turkmenistan' },
  {
    label: 'TC (Turks and Caicos Islands)',
    countryCode: 'TC',
    name: 'Turks and Caicos Islands',
  },
  { label: 'TV (Tuvalu)', countryCode: 'TV', name: 'Tuvalu' },
  { label: 'UG (Uganda)', countryCode: 'UG', name: 'Uganda' },
  { label: 'UA (Ukraine)', countryCode: 'UA', name: 'Ukraine' },
  {
    label: 'AE (United Arab Emirates)',
    countryCode: 'AE',
    name: 'United Arab Emirates',
  },
  { label: 'GB (United Kingdom)', countryCode: 'GB', name: 'United Kingdom' },
  { label: 'US (United States)', countryCode: 'US', name: 'United States' },
  {
    label: 'UM (United States Minor Outlying Islands)',
    countryCode: 'UM',
    name: 'United States Minor Outlying Islands',
  },
  { label: 'UY (Uruguay)', countryCode: 'UY', name: 'Uruguay' },
  { label: 'UZ (Uzbekistan)', countryCode: 'UZ', name: 'Uzbekistan' },
  { label: 'VU (Vanuatu)', countryCode: 'VU', name: 'Vanuatu' },
  { label: 'VE (Venezuela)', countryCode: 'VE', name: 'Venezuela' },
  { label: 'VN (Viet Nam)', countryCode: 'VN', name: 'Viet Nam' },
  {
    label: 'VG (Virgin Islands, British)',
    countryCode: 'VG',
    name: 'Virgin Islands, British',
  },
  {
    label: 'VI (Virgin Islands, U.S.)',
    countryCode: 'VI',
    name: 'Virgin Islands, U.S.',
  },
  {
    label: 'WF (Wallis and Futuna)',
    countryCode: 'WF',
    name: 'Wallis and Futuna',
  },
  { label: 'EH (Western Sahara)', countryCode: 'EH', name: 'Western Sahara' },
  { label: 'YE (Yemen)', countryCode: 'YE', name: 'Yemen' },
  { label: 'ZM (Zambia)', countryCode: 'ZM', name: 'Zambia' },
  { label: 'ZW (Zimbabwe)', countryCode: 'ZW', name: 'Zimbabwe' },
];

export const countryOptionsForAccount = () =>
  accountCountries.map(country => ({
    label: country.label,
    value: country.countryCode,
    isDisabled: country.isDisabled,
  }));
